/**
 * Chip dei tag (F-079). Un solo componente per tutti i posti che li mostrano —
 * dettaglio titolo, wishlist, vista per tag — perché la resa di un tag non deve
 * poter divergere fra una schermata e l'altra.
 *
 * I chip sono **collegamenti** alla vista del tag, non decorazioni: è la
 * richiesta del TODO («cliccando su un tag si apre la pagina di vista del
 * tag»), e vale ovunque compaiano. L'unica eccezione è dentro il modal, dove
 * navigare via mentre si sta modificando perderebbe le modifiche: lì si passa
 * `onRemove` e i chip diventano pulsanti di rimozione.
 */

import { Link } from 'react-router-dom';
import './tags.css';

type TagListProps = {
  tags: string[];
  /** `small` per gli elenchi (wishlist), `normal` altrove. */
  size?: 'small' | 'normal';
  /** Se presente i chip NON navigano: diventano pulsanti «togli». */
  onRemove?: (tag: string) => void;
};

export function TagList({ tags, size = 'normal', onRemove }: TagListProps) {
  if (tags.length === 0) return null;
  const className = size === 'small' ? 'tag-list tag-list--small' : 'tag-list';

  return (
    <ul className={className}>
      {tags.map((tag) => (
        <li key={tag}>
          {onRemove ? (
            <button type="button" className="tag tag--removable" onClick={() => onRemove(tag)}>
              {tag}
              <span aria-hidden="true"> ✕</span>
              <span className="visually-hidden"> — togli il tag {tag}</span>
            </button>
          ) : (
            <Link className="tag" to={`/tags/${encodeURIComponent(tag)}`}>
              {tag}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
}
